import React from "react";

const CommonFooter = () => {
  return (
    <div>
      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0">2014-2026 © Pereco. All Right Reserved</p>
        <p>
          Designed &amp; Developed By
          <a
            href="https://perennialcode.in/"
            className="link-primary ms-1"
            target="_blank"
            rel="noopener noreferrer"
          >
            Pereco
          </a>
        </p>
      </div>
    </div>
  );
};

export default CommonFooter;
